export const unlimitedSubscription = { totalSeats: null }
